module.exports = __webpack_public_path__ + "assets/images/T-icon.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/T-icon.png
// module id = 1431
// module chunks = 1